module.exports = __webpack_public_path__ + "41d3f20ed186e65e0f8c9882622e514b.png";